<div class="background-image">
  <tc-header>
    <tc-logo color="white" tagline="true"></tc-logo>
  </tc-header>

  <tc-login
    (loginUser)="onLogin($event)"
    (checkEmailDomain)="onCheckEmailDomain($event)"
    (verify2FA)="onVerify2FA($event)"
    (verify2FAViaBackup)="onVerify2FAViaRecoveryCode($event)"
    (enable2FA)="onEnable2FA($event)"
    (backToLogin)="onBackToLogin()"
    (clearRecovery)="onClearRecoveryAndGoInside()"
    [loginState]="loginState$ | async"
    [identity]="identity$ | async"
    [configure2FA]="configure2FA$ | async"
  ></tc-login>
  <tc-title></tc-title>
</div>
